// Change colour of footer button on Subscribe form
(function($) {
	$(document).ready(function() {

		const english = $('.nav-en')
		const home = window.location.origin
		const path = window.location.pathname

		english.on('click', function(e) {

			if(path === '/fr/francais-non-disponible/') {
				// if the page is "français non disponible
				e.preventDefault()

				if(document.referrer.indexOf(window.location.origin) === 0) {
					// origin is at the beginning of referrer, this means it's on the same site
					window.history.back()
				} else {
					// if the previous page was a from a different domain or an empty new tab, go push the Home Page as athe las page in the browser history and go back
					window.location.href = home

				}
				return false
			}

		});

		// Explore Homepage
		const explore = $('.explore-container .explore-principle')
		const card = $('.explore-container .card-right-text')
		explore.first().addClass('active').css('font-weight', 'bold')
		$('.explore-list').first().addClass('yellow-line')

		explore.click(function() {

			const show = $('.' + this.id).fadeIn(1500)

			card.not(show).css('display', 'none')

			$('li').removeClass('yellow-line')
			explore.removeClass('active').css('font-weight', '400')
			$(this).addClass('active').css('font-weight', 'bold')
			$('li[data-content=' + this.id + ']').addClass('yellow-line')
			show.css('display', 'block')

		});

		// Footer Subscribe
		const email = $('.footer-input')
		const emailBtn = $('.footer-subscribe-btn')
		const span = $('.sub-arrow')

		email.on('input', function() {

			if(email.val() === '') {
				emailBtn.css('background-color', '#440021')
				span.removeClass('red-arrow')
			} else {
				emailBtn.css('background-color', '#fff')
				span.addClass('red-arrow')

			}

		});

		// Equal height boxes
		function setEqualHeights() {

			// Get all the elements in the DOM with the data-equal-height attribute
			const elements = document.querySelectorAll('[data-equal-height]')

			// Bail if we don't have any
			if(0 === elements.length) {
				return false
			}

			// Group the elements based on the value of their attribute (we could have many groups of elements)
			const grouped = Array.from(elements).reduce((carry, current) => {
				const key = current.getAttribute('data-equal-height')
				carry.set(key, [...carry.get(key) || [], current])
				return carry
			}, new Map())

			// Iterate over each group's elements and set their height to that of the tallest one
			grouped.forEach(group => {
				group.forEach(element => element.style.height = 'auto')
				const maxHeight = group.reduce((carry, current) => Math.max(carry || 0, current.offsetHeight))
				group.forEach(element => {
					if(window.innerWidth >= (element.getAttribute('data-equal-height-min-width') || 0)) {
						element.style.height = `${maxHeight}px`
					}
				})
			})

		}

		// set heights on document ready
		setEqualHeights();

		// listen for window resize events and set heights then too
		window.addEventListener('resize', setEqualHeights);

	})

})(jQuery);